(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pspool-publico-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRoot = (root) => {
      if (!root || root.dataset.pspoolInitialised === 'true') return;
      root.dataset.pspoolInitialised = 'true';

      const image = root.querySelector('[data-pspool-image]');

      root.querySelectorAll('[data-pspool-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.pspoolThumbSrc;
          if (!image || !src) return;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', src);
        });
      });

      const select = root.querySelector('[data-pspool-variant-select]');
      if (!select) return;

      const price = root.querySelector('[data-pspool-price]');
      const priceNoVat = root.querySelector('[data-pspool-price-no-vat]');
      const stock = root.querySelector('[data-pspool-stock]');
      const skuRow = root.querySelector('[data-pspool-sku-row]');
      const sku = root.querySelector('[data-pspool-sku]');
      const compareWrap = root.querySelector('[data-pspool-compare-wrap]');
      const compare = root.querySelector('[data-pspool-compare]');

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;

        if (price) price.textContent = option.dataset.pspoolPrice || '';

        if (priceNoVat) priceNoVat.textContent = option.dataset.pspoolPriceNoVat || '';

        if (skuRow && sku) {
          sku.textContent = option.dataset.pspoolSku || '';
          skuRow.hidden = !option.dataset.pspoolSku;
        }

        if (stock) {
          const available = option.dataset.pspoolAvailable === 'true';
          stock.textContent = available ? stock.dataset.textInStock : stock.dataset.textSoldOut;
          stock.classList.toggle('is-available', available);
        }

        if (compareWrap && compare) {
          compare.textContent = option.dataset.pspoolCompare || '';
          compareWrap.hidden = !option.dataset.pspoolCompare;
        }

        if (image && option.dataset.pspoolImage) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', option.dataset.pspoolImage);
        }
      });
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-pspool-root]').forEach(initRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
